<template>
  <footer>
    <div class="followCnt">
      <h4>Follow Us</h4>
      <div class="cnt">
        <a href="https://twitter.com/TeamUpForImpact/"
          target="_blank" class="followItem tw"
          v-on:click="this.$emit('fireal', 'open_socmed', 'footer', {name: 'Twitter'})"></a>
        <a href="https://web.facebook.com/teamupforimpact"
          target="_blank" class="followItem fb"
          v-on:click="this.$emit('fireal', 'open_socmed', 'footer', {name: 'Facebook'})"></a>
        <a href="https://www.tiktok.com/@teamupforimpact"
          target="_blank" class="followItem tk"
          v-on:click="this.$emit('fireal', 'open_socmed', 'footer', {name: 'TikTok'})"></a>
        <a href="https://www.youtube.com/channel/UCoA3ryh-cDJwzcbepH3LJOA"
          target="_blank" class="followItem yt"
          v-on:click="this.$emit('fireal', 'open_socmed', 'footer', {name: 'Youtube'})"></a>
        <a href="https://www.instagram.com/teamupforimpact/"
          target="_blank" class="followItem ig"
          v-on:click="this.$emit('fireal', 'open_socmed', 'footer', {name: 'Instagram'})"></a>
      </div>
    </div>
    <div class="footerCnt">
      <div class="cnt">
        <div class="footerTop">
          <div class="logo">
            <img src="../assets/logo-tufi-long.png">
          </div>
          <div class="footerMenu">
            <li>
              <a href="/team-up-everyday"
                v-on:click="this.$emit('fireal', 'navigate', 'footer', {
                  name: 'Team Up Everyday',
                })">Team Up Everyday</a>
            </li>
            <li>
              <a href="/untukmubumiku"
                v-on:click="this.$emit('fireal', 'navigate', 'footer', {
                  name: '#Untukmubumiku',
                })">#Untukmubumiku</a>
            </li>
            <li>
              <a href="/blog"
                v-on:click="this.$emit('fireal', 'navigate', 'footer', {
                  name: 'Blog',
                })">Blog</a>
            </li>
            <li>
              <div class="fmItem" data-tf-popup="Ek3sSuIw"
                data-tf-iframe-props="title=TUFI Feedback"
                data-tf-medium="snippet"
                v-on:click="this.$emit('fireal', 'open_feedback', 'footer')">Feedback</div>
            </li>
          </div>
        </div>
        <div class="copyright">&copy; Copyright {{d.getFullYear()}} -
          Team Up For Impact - All right reserved<br />
          <a href="/privacy-policy"
            v-on:click="this.$emit('fireal', 'open_privacy_policy', 'footer')">Privacy Policy</a>
          <span>&bull;</span>
          <a href="/term-of-use"
            v-on:click="this.$emit('fireal', 'open_term_of_use', 'footer')">Term of Use</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      d: new Date(),
    };
  },
  methods: {
  },
  mounted() {
  },
};
</script>

<style scoped lang="scss">
footer{
  .followCnt{
    padding: 60px 0;
    @media (max-width: 680px) {
      padding-bottom: 40px;
    }
    h4{
      text-align: center;
      font-size: 18px;
      text-transform: uppercase;
      margin: 0 0 26px;
      color: #5351a4;
      color: #767676;
      font-family: 'GolosUIWebBold', sans-serif;
    }
    .cnt{
      display: flex;
      justify-content: center;
      .followItem{
        width: 54px; height: 54px;
        background-size: 100% auto;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 8px;
        margin: 0 20px;
        &.fb{
          background-image: url(../assets/sc-fb.png);
        }
        &.tw{
          background-image: url(../assets/sc-tw.png);
        }
        &.tk{
          background-image: url(../assets/tiktok.png);
        }
        &.yt{
          background-image: url(../assets/sc-yt.png);
        }
        &.ig{
          background-image: url(../assets/sc-ig.png);
          background-size: 104% auto;
        }
      }
    }
  }
  .footerCnt{
    background-color: #fef7e5;
    .cnt{
      .footerTop{
        display: flex;
        padding: 60px 0;
        @media (max-width: 860px) {
          display: block;
          text-align: center;
          padding-bottom: 40px;
        }
        .logo{
          @media (max-width: 860px) {
            margin-bottom: 20px;
          }
          img{
            height: 46px;
          }
        }
        .footerMenu{
          display: flex;
          margin-left: auto;
          align-items: flex-end;
          @media (max-width: 860px) {
            justify-content: center;
            flex-wrap: wrap;
          }
          li{
            list-style: none;
            a, .fmItem{
              display: block;
              text-transform: uppercase;
              color: #767676;
              font-weight: bold;
              margin-left: 40px;
              font-size: 18px;
              margin-bottom: 10px;
              transition: all .3s ease;
              cursor: pointer;
              @media (max-width: 860px) {
                margin: 0 16px 20px;
              }
              @media (max-width: 680px) {
                margin: 0 10px 10px;
                font-size: 16px;
              }
              @media (max-width: 960px) {
                margin-left: 20px;
                font-size: 16px;
              }
              &:hover{
                color: #5351a4;
              }
            }
          }
        }
      }
      .copyright{
        text-align: center;
        text-transform: uppercase;
        font-size: 14px;
        font-weight: bold;
        color: #767676;
        padding: 0 0 20px;
        line-height: 1.5;
        a{
          color: #767676;
          &:hover{
            color: #5351a4;
          }
        }
        span{
          margin: 0 10px;
        }
        @media (max-width: 680px) {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
